export default __webpack_public_path__ + "static/media/webrtc.2af61ab6.svg";